import { Component, Inject, Input, ViewChild, ViewEncapsulation, ɵgetHostElement, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ComboBoxComponent } from '@progress/kendo-angular-dropdowns';
import { Observable } from 'rxjs';
import { finalize, map } from 'rxjs/operators';
import { DataWithPagingMetadata } from '~/infrastructure/paging';
import { deactivationNoteListing, deactivationNoteSummary } from '~/models/modules/deactivationNote';
import { AccountsService } from '~/services/administration.ts/accounts';
import { UsersService } from '~/services/administration.ts/users';
import { AddressesService } from '~/services/modules/stocks/addresses';
import { CategoriesService } from '~/services/modules/stocks/categories';
import { CustomersService } from '~/services/modules/stocks/customers';
import { FilesService } from '~/services/modules/stocks/files';
import { StockItemsService } from '~/services/modules/stocks/items';
import { LocationTypesService } from '~/services/modules/stocks/location-types';
import { LocationsService } from '~/services/modules/stocks/locations';
import { DeactivationNotesService } from '~/services/modules/stocks/deactivationNotes';
import { UnitOfMeasuresService } from '~/services/modules/stocks/unit-of-measure';
import { VendorsService } from '~/services/modules/stocks/vendors';
import { ThemeManagerService } from '~/services/theme-manager';
import { GridLayoutManagerService } from '~/shared/components/grid/layout/grid-layout-manager';
import { LayoutManagerService, PORTAL_DATA } from '~/shared/components/layout/layout-manager';
import { LayoutComponent } from '../layout/layout.component';
import { SecurityService } from '../../../services/security.service';
import { DisposeToService } from '~/services/modules/stocks/dispose-to';
import { PurchaseOrdersService } from '~/services/modules/stocks/purchase-orders';
import { SalesOrdersService } from '~/services/modules/stocks/sales-orders';
import { DepartmentsService } from '~/services/modules/assets/department';
import { StatusesService } from '~/services/modules/assets/status';
import { ConditionsService } from '~/services/modules/assets/condition';
import { AssetTypeService } from '~/services/modules/assets/assetType';
import { AppRolesService } from '~/services/administration.ts/approles';
import { FacilityService } from './../../../services/modules/stocks/facility';
import { AssetModelService } from '~/services/modules/assets/asset-model.service';
import { BuildingService } from '~/services/modules/stocks/building';
import { EntityStatus } from '~/shared/enums/itemsTypes';
import { AssetService } from '~/services/modules/assets/asset.service';
import { FundingSourceService } from '~/services/modules/assets/fundingSource';
import { AssetPurchaseOrdersService } from '~/services/modules/assets/orders/asset-purchase-orders.service';
import { SharedService } from '~/services/sharedService';
import { AssetReservationService } from '~/services/modules/assets/transactions/asset-reservation.service';
import { ScheduleMaintenanceService } from '~/services/modules/assets/transactions/schedule-maintenance.service';
import { FloorService } from '~/services/modules/stocks/floor';

@Component({
    selector: 'app-reactivate-data',
    templateUrl: './reactivate-data.component.html',
    styleUrls: ['./reactivate-data.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ReactivateDataComponent {
    @ViewChild('Kendo_Combo_Notes') KendoComboNotes: ComboBoxComponent;

    _isNew: boolean;
    _active: boolean;
    _theme: string;
    _note = new FormControl();
    _form: FormGroup;
    currentStep = 1;
    inavlidform: boolean = true;
    _itemId: any;
    _stockItem: any;
    _selectedAccounts: any = [];
    _showAccountsGrid = false;
    _notes: deactivationNoteSummary[];
    _pageName: string = '';
    _enableSiteSelection: boolean = true;
    _locationTypePage: boolean = false;
    _currentUser: any;
    _batch: any;
    batchstatus: any;

    constructor(
        private _themeManager: ThemeManagerService,
        private _layoutManager: LayoutManagerService,
        private _fb: FormBuilder,
        private _stockItemsService: StockItemsService,
        private _unitOfMeasuresService: UnitOfMeasuresService,
        private _accountsService: AccountsService,
        private _notesService: DeactivationNotesService,
        private _categoriesService: CategoriesService,
        private _customersService: CustomersService,
        private _vendorsService: VendorsService,
        private _departmentsService: DepartmentsService,
        private _conditionsService: ConditionsService,
        private _statusesService: StatusesService,
        private _addressesService: AddressesService,
        private _appRolesService: AppRolesService,
        private _filesService: FilesService,
        private _usersService: UsersService,
        private _locationsService: LocationsService,
        private _locationypesService: LocationTypesService,
        private _FacilityService: FacilityService,
        private _gridLayoutManagerService: GridLayoutManagerService,
        private _layoutComponent: LayoutComponent,
        private _securityService: SecurityService,
        private _disposeToService: DisposeToService,
        private _poService: PurchaseOrdersService,
        private _soService: SalesOrdersService,
        private _assetTypeService: AssetTypeService,
        private _assetModelService: AssetModelService,
        private _assetService: AssetService,
        private _fundingSourceService: FundingSourceService,
        private _BuildingService: BuildingService,
        private _assetPurchaseOrdersService: AssetPurchaseOrdersService,
        private _assetReservationService: AssetReservationService,
        private _scheduleMaintenanceService: ScheduleMaintenanceService,
        private _FloorService: FloorService,
        private _sharedService: SharedService,
        @Inject(PORTAL_DATA) public data: any
    ) {
        if (data) {
            this._isNew = data.isNew;

            if (data.model.itemId)
                this._itemId = data.model.itemId;
            else (data.model.batch)
            this._batch = data.model.batch;
            this.batchstatus = data.model.Batchstatus

            this._pageName = data.model.pageName;
            this._active = true;
            this._locationTypePage = data.model.locationTypePage;
        }
        this._themeManager.themeChange.subscribe((data) => {
            this._theme = data;
        });
        this._layoutManager.applyOverly();
    }
    ngOnInit() {

        this._initForm();
        this._onDelete();
        switch (this._pageName) {
            case 'stockItems':
                this._loadStockItem();
                break;
            case 'uom':
                this._loadUOMItem();
                break;
            case 'categories':
                this._loadCategories();
                break;
            case 'customers':
                this._loadCustomers();
                break;
            case 'vendors':
                this._loadVendors();
                break;
            case 'addresses':
                this._loadAddresses();
                break;
            case 'files':
                this._loadFiles();
                break;
            case 'users':
                this._loadUsers();
                break;
            case 'locations':
                this._loadLocations();
                break;
            case 'locationTypes':
                this._loadLocationTypes();
                break;
            case 'facility':
                this._loadLocationTypes();
                break;
            case 'disposeTo':
                this._loadDisposeTo();
                break;
            case 'purchaseOrders':
                this._loadPurchaseOrder();
                break;
            case 'salesOrders':
                this._loadSalesOrder();
                break;
            case 'appRoles':
                this._loadSecurityLevel();
                break;
            case 'asset-purchaseOrders':
                this._loadAssetPurchaseOrder();
                break;

            case 'floor':
                this._loadLocationTypes();
                break;

            default:
                break;
        }
        this._loadNotes();
        // setTimeout(() => {
        //     this.KendoComboNotes.toggle(true);
        //     this.KendoComboNotes.focus();
        //     let NotesSelection = this.KendoComboNotes;
        //     NotesSelection['hostElement'].nativeElement.classList.add('focusedCombobox');
        // }, 300);

        this._currentUser = this._securityService.currentUser;
    }

    _loadNotes() {
        this._notesService.getNotesByPage(this._pageName).subscribe(res => {
            this._notes = res;
        });
    }

    _loadStockItem(): void {
        this._stockItemsService.getStockItem(this._itemId ?? this._batch)
            .pipe(finalize(() => {
                this._showAccountsGrid = true;
                setTimeout(() => {
                    this.KendoComboNotes.toggle(true);
                    this.KendoComboNotes.focus();
                    let NotesSelection = this.KendoComboNotes;
                    ɵgetHostElement(NotesSelection).classList.add('focusedCombobox');
                }, 300);
            }))
            .subscribe(res => {
                for (let i = 0; res.stockItemSites && i < res.stockItemSites.length; i++) {
                    this._selectedAccounts.push({
                        siteId: res.stockItemSites[i].site != null ? res.stockItemSites[i].site.id : null,
                        accountId: res.stockItemSites[i].account.id
                    });
                }
            });
    }

    _loadUOMItem(): void {
        this._enableSiteSelection = false;
        this._unitOfMeasuresService.getUnitOfMeasure(this._itemId ?? this._batch)
            .pipe(
                finalize(() => {
                    this._showAccountsGrid = true;
                    setTimeout(() => {
                        this.KendoComboNotes.toggle(true);
                        this.KendoComboNotes.focus();
                        ɵgetHostElement(this.KendoComboNotes).classList.add('focusedCombobox');
                    }, 300);
                })
            )
            .subscribe(res => {
                for (let i = 0; res.unitOfMeasureAccounts && i < res.unitOfMeasureAccounts.length; i++) {
                    this._selectedAccounts.push(res.unitOfMeasureAccounts[i].account.id);
                }
            });
    }

    _loadCategories(): void {
        this._enableSiteSelection = false;
        this._categoriesService.getCategory(this._itemId ?? this._batch)
            .pipe(finalize(() => {
                this._showAccountsGrid = true;
                setTimeout(() => {
                    this.KendoComboNotes.toggle(true);
                    this.KendoComboNotes.focus();
                    let notesSelection = this.KendoComboNotes;
                    ɵgetHostElement(notesSelection).classList.add('focusedCombobox');
                }, 300);
            }))
            .subscribe(res => {
                for (let i = 0; res.categoryAccounts && i < res.categoryAccounts.length; i++) {
                    this._selectedAccounts.push(res.categoryAccounts[i].account.id);
                }
            });
    }
    _loadCustomers(): void {
        this._customersService.getCustomer(this._itemId ?? this._batch)
            .pipe(finalize(() => {
                this._showAccountsGrid = true;
                setTimeout(() => {
                    this.KendoComboNotes.toggle(true);
                    this.KendoComboNotes.focus();
                    let NotesSelection = this.KendoComboNotes;
                    ɵgetHostElement(NotesSelection).classList.add('focusedCombobox');
                }, 300);
            }))
            .subscribe(res => {
                for (let i = 0; res.customerSites && i < res.customerSites.length; i++) {
                    this._selectedAccounts.push({
                        siteId: res.customerSites[i].site != null ? res.customerSites[i].site.id : null,
                        accountId: res.customerSites[i].account.id
                    });
                }
            });
    }

    _loadVendors(): void {
        this._vendorsService.getVendor(this._itemId ?? this._batch)
            .pipe(finalize(() => {
                this._showAccountsGrid = true;
                setTimeout(() => {
                    this.KendoComboNotes.toggle(true);
                    this.KendoComboNotes.focus();
                    let NotesSelection = this.KendoComboNotes;
                    ɵgetHostElement(NotesSelection).classList.add('focusedCombobox');
                }, 300);
            }))
            .subscribe(res => {
                for (let i = 0; res.vendorSites && i < res.vendorSites.length; i++) {
                    this._selectedAccounts.push({
                        siteId: res.vendorSites[i].site != null ? res.vendorSites[i].site.id : null,
                        accountId: res.vendorSites[i].account.id
                    });
                }
            });
    }
    _loadAddresses(): void {
        this._enableSiteSelection = false;
        this._addressesService.getAddress(this._itemId ?? this._batch)
            .pipe(finalize(() => {
                this._showAccountsGrid = true;
                setTimeout(() => {
                    this.KendoComboNotes.toggle(true);
                    this.KendoComboNotes.focus();
                    let notesSelection = this.KendoComboNotes;
                    ɵgetHostElement(notesSelection).classList.add('focusedCombobox');
                }, 300);
            }))
            .subscribe(res => {
                for (let i = 0; res.addressAccounts && i < res.addressAccounts.length; i++) {
                    this._selectedAccounts.push(res.addressAccounts[i].account.id);
                }
            });
    }

    _loadSecurityLevel(): void {

        this._appRolesService.getAppRole(this._itemId ?? this._batch)
            .pipe(finalize(() => {
                this._showAccountsGrid = true;
                setTimeout(() => {
                    this.KendoComboNotes.toggle(true);
                    this.KendoComboNotes.focus();
                    let NotesSelection = this.KendoComboNotes;
                    ɵgetHostElement(NotesSelection).classList.add('focusedCombobox');
                }, 300);
            }))
            .subscribe(res => {
                for (let i = 0; res.AppRoleAccounts && i < res.AppRoleAccounts.length; i++) {
                    this._selectedAccounts.push({
                        accountId: res.AppRoleAccounts[i].AccountId
                    });
                    if (i == res.AppRoleAccounts.length - 1) {
                        setTimeout(() => {
                            this._enableSiteSelection = false;
                        }, 500);
                    }
                }
            });
    }

    _loadFiles(): void {
        this._filesService.getFile(this._itemId ?? this._batch)
            .pipe(finalize(() => {
                this._showAccountsGrid = true;
                setTimeout(() => {
                    this.KendoComboNotes.toggle(true);
                    this.KendoComboNotes.focus();
                    let notesSelection = this.KendoComboNotes;
                    ɵgetHostElement(notesSelection).classList.add('focusedCombobox');
                }, 300);
            }))
            .subscribe(res => {
                for (let i = 0; res.fileAccounts && i < res.fileAccounts.length; i++) {
                    this._selectedAccounts.push({
                        accountId: res.fileAccounts[i].account.id
                    });
                    if (i == res.fileAccounts.length - 1) {
                        setTimeout(() => {
                            this._enableSiteSelection = false;
                        }, 500);
                    }
                }
            });
    }
    _loadUsers(): void {
        this._usersService.getUser(this._itemId ?? this._batch[0].id)
            .pipe(finalize(() => {
                this._showAccountsGrid = true;
                setTimeout(() => {
                    this.KendoComboNotes.toggle(true);
                    this.KendoComboNotes.focus();
                    let NotesSelection = this.KendoComboNotes;
                    ɵgetHostElement(NotesSelection).classList.add('focusedCombobox');
                }, 300);
            }))
            .subscribe(res => {
                for (let i = 0; res.userSites && i < res.userSites.length; i++) {
                    this._selectedAccounts.push({
                        siteId: res.userSites[i].site != null ? res.userSites[i].site.id : null,
                        accountId: res.userSites[i].account.id
                    });
                }
            });
    }
    _loadLocations(): void {

        this._locationsService.getLocation(this._itemId ?? this._batch)
            .pipe(finalize(() => {
                this._showAccountsGrid = true;
                setTimeout(() => {
                    this.KendoComboNotes.toggle(true);
                    this.KendoComboNotes.focus();
                    let NotesSelection = this.KendoComboNotes;
                    ɵgetHostElement(NotesSelection).classList.add('focusedCombobox');
                }, 300);
            }))
            .subscribe(res => {
                this._selectedAccounts.push({
                    accountId: res.account.id
                });
                setTimeout(() => {
                    this._enableSiteSelection = false;
                }, 500);
            });
    }
    _loadDisposeTo(): void {
        this._disposeToService.getDisposeToById(this._itemId ?? this._batch)
            .pipe(finalize(() => {
                this._showAccountsGrid = true;
                setTimeout(() => {
                    this.KendoComboNotes.toggle(true);
                    this.KendoComboNotes.focus();
                    let NotesSelection = this.KendoComboNotes;
                    ɵgetHostElement(NotesSelection).classList.add('focusedCombobox');
                }, 300);
            }))
            .subscribe((res: any) => {
                this._selectedAccounts.push({
                    accountId: res.site?.account?.id
                });
                setTimeout(() => {
                    this._enableSiteSelection = false;
                }, 500);
            });
    }
    _loadPurchaseOrder(): void {
        this._poService.getPurchaseOrder(this._itemId)
            .pipe(finalize(() => {
                this._showAccountsGrid = true;
                setTimeout(() => {
                    this.KendoComboNotes.toggle(true);
                    this.KendoComboNotes.focus();
                    let NotesSelection = this.KendoComboNotes;
                    ɵgetHostElement(NotesSelection).classList.add('focusedCombobox')
                }, 300);
            }))
            .subscribe((res: any) => {
                this._selectedAccounts.push({
                    accountId: res.site?.account?.id
                });
                setTimeout(() => {
                    this._enableSiteSelection = false;
                }, 500);
            });
    }
    _loadSalesOrder(): void {
        this._soService.getSalesOrder(this._itemId)
            .pipe(finalize(() => {
                this._showAccountsGrid = true;
                setTimeout(() => {
                    this.KendoComboNotes.toggle(true);
                    this.KendoComboNotes.focus();
                    let NotesSelection = this.KendoComboNotes;
                    ɵgetHostElement(NotesSelection).classList.add('focusedCombobox')
                }, 300);
            }))
            .subscribe((res: any) => {
                this._selectedAccounts.push({
                    accountId: res.site?.account?.id
                });
                setTimeout(() => {
                    this._enableSiteSelection = false;
                }, 500);
            });
    }
    _loadLocationTypes(): void {
        setTimeout(() => {
            this.KendoComboNotes.toggle(true);
            this.KendoComboNotes.focus();
            let NotesSelection = this.KendoComboNotes;
            ɵgetHostElement(NotesSelection).classList.add('focusedCombobox');
        }, 300);
    }
    _loadAssetPurchaseOrder(): void {
        this._assetPurchaseOrdersService.getPurchaseOrderById(this._itemId ?? this._batch[0].id)
            .pipe(finalize(() => {
                this._showAccountsGrid = true;
                setTimeout(() => {
                    //   this.KendoComboNotes.toggle(true);
                    //   this.KendoComboNotes.focus();
                    //   let NotesSelection = this.KendoComboNotes;
                    //  ɵgetHostElement(NotesSelection).classList.add('focusedCombobox')
                }, 300);
            }))
            .subscribe((res: any) => {
                this._selectedAccounts.push({
                    accountId: res.site?.account?.id
                });
                setTimeout(() => {
                    this._enableSiteSelection = false;
                }, 500);
            });
    }
    _getAccounts = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
        return this._accountsService.getAccounts(params, model);
    }

    _onCancel() {
        this._closeForm();
    }

    _closeForm() {
        this._active = false;
        //this._gridLayoutManagerService.setGridDataSubjects(this._pageName, true);

        this._sharedService.ActivateOrDeactivate.emit(true);
        this.ngOnDestroy();
    }

    ngOnDestroy() {
        this._layoutManager.removeOverlay();
    }

    _onStateChanges(e: any) {
        if (e === 'minimized') {
            this._layoutManager.removeOverlay();
        } else {
            this._layoutManager.applyOverly();
        }
    }

    _noteSubmited(event: any) {
        if (event) {
            this.inavlidform = false;
        } else {
            this.inavlidform = true;
        }
        setTimeout(() => {
            this.KendoComboNotes.toggle(false);
            this.currentStep = 3;
            let NotesSelection = this.KendoComboNotes;
            ɵgetHostElement(NotesSelection).classList.remove('focusedCombobox');
            let notesclosedvalue = this.KendoComboNotes;
            ɵgetHostElement(notesclosedvalue).children[0].classList.remove('k-state-focused');
        });
    }

    _skipNotes() {

        this.KendoComboNotes.toggle(false);
        this.currentStep = 3;
        let NotesSelection = this.KendoComboNotes;
        ɵgetHostElement(NotesSelection).classList.remove('focusedCombobox');
    }

    _noteFocusEvent() {
        setTimeout(() => {
            this.KendoComboNotes.toggle(true);
            this.KendoComboNotes.focus();
            this.currentStep = 1;
            let NotesSelection = this.KendoComboNotes;
            ɵgetHostElement(NotesSelection).classList.add('focusedCombobox');
        });
    }

    _notesComboOpening() {
        this.currentStep = 1;
        let notesclosedvalue = this.KendoComboNotes;
        ɵgetHostElement(notesclosedvalue).children[0].classList.add('k-state-focused');
    }

    _onDelete(e: any = null) {
        this._currentUser = this._securityService.currentUser;
        let obj = {};
        if (this._itemId) {
            obj = {
                id: this._itemId,
                noteId: this._note.value ? this._note.value.id : null,
                accountSites: this._selectedAccounts
            };
        }
        else {
            obj = {
                id: null,
                batch: this._batch,
                ListOf: this._batch.map((a: any) => a.id),
                noteId: this._note.value ? this._note.value.id : null,
                accountSites: this._selectedAccounts,
                Batchstatus: this.batchstatus
            };
        }
        switch (this._pageName) {
            case 'stockItems':
                this._ReactivateStockItem(obj);
                break;
            case 'uom':
                this._ReactivateUOMItem(obj);
                break;
            case 'categories':
                this._ReactivateCategory(obj);
                break;
            case 'customers':
                this._ReactivateCustomers(obj);
                break;
            case 'vendors':
                this._ReactivateVendor(obj);
                break;
            case 'addresses':
                this._ReactivateAddress(obj);
                break;
            case 'files':
                this._DeactivateFiles(obj);
                break;
            case 'users':
                this._ReactivateUser(obj);
                break;
            case 'persons':
                this._ReactivatePerson(obj);
                break;
            case 'locations':
                this._ReactivateLocation(obj);
                break;
            case 'locationTypes':
                this._DeactivateLocationType(obj);
                break;
            case 'facility':
                this._ReactivateFacility(obj);
                break;
            case 'building':
                this._ReactivateBuilding(obj);
                break;
            case 'disposeTo':
                this._ReactivateDisposeTo(obj);
                break;
            case 'purchaseOrders':
                this._DeactivatePurchaseOrders(obj);
                break;
            case 'salesOrders':
                this._DeactivateSalesOrders(obj);
                break;
            case 'departments':
                this._ReactivateDepartment(obj);
                break;
            case 'appRoles':
                this._DeactivateSecurityLevel(obj);
                break;
            case 'statuses':
                this._ReactivateStatus(obj);
                break;
            case 'conditions':
                this._ReactivateCondition(obj);
                break;
            case 'asset-types':
                this._ReactivateAssetType(obj);
                break;
            case 'asset-models':
                this._ReactivateAssetModel(obj);
                break;
            case 'assets':
                this._ReactivateAsset(obj);
                break;
            case 'asset-inventory':
                this._ReactivateAsset(obj);
                break;
            case 'fundingsource':
                this._ReactivateFundingSource(obj);
                break;
            case 'asset-purchaseOrders':
                this._ReactivateAssetPurchaseOrders(obj);
                break;
            case 'asset-reservation':
                this._ReactivateAssetReservation(obj);
                break;
                break;
            case 'asset-reservation-list':
                this._ReactivateAssetReservation(obj);
                break;
            case 'floor':
                this._ReactivateFloor(obj);
                break;
            case 'schedule-maintenance':
            case 'ScheduleMaintenance':
                this._ReactivateScheduleMaintenance(obj);
                break;

            default:
                break;
        }
    }



    _ReactivateCondition(obj: any) {
        if (this._currentUser.isEnterprise) {
            (this._itemId ? this._conditionsService.reactivateCondition(obj) : this._conditionsService.reactivateBatchCondition(obj))

                .subscribe((response: any) => {
                    //this._closeForm(); //temp
                    if (response != null && response['message'] != null) {
                        this._layoutComponent.openPopup({
                            title: 'Alert',
                            message: response['message'],
                            withoutConfirm: true
                        });
                        if (response['close'] != null) {
                            if (response['close'] == true) {
                                this._closeForm();
                            } else {
                                return;
                            }
                        }
                    }
                });
        }
        else {
            (this._itemId ? this._conditionsService.reactivateCondition(obj) : this._conditionsService.reactivateBatchCondition(obj))

                .subscribe((response: any) => {
                    //this._closeForm(); //temp
                    if (response != null && response['message'] != null) {
                        this._layoutComponent.openPopup({
                            title: 'Alert',
                            message: response['message'],
                            withoutConfirm: true
                        });
                        if (response['close'] != null) {
                            if (response['close'] == true) {
                                this._closeForm();
                            } else {
                                return;
                            }
                        }
                    }
                });
        }
    }

    _ReactivateAssetType(obj: any) {
        if (this._currentUser.isEnterprise) {
            (this._itemId ? this._assetTypeService.reactivateAssetType(obj) : this._assetTypeService.reactivateAssetTypeBatch(obj))

                .subscribe((response: any) => {
                    //this._closeForm(); //temp
                    if (response != null && response['message'] != null) {
                        this._layoutComponent.openPopup({
                            title: 'Alert',
                            message: response['message'],
                            withoutConfirm: true
                        });
                        if (response['close'] != null) {
                            if (response['close'] == true) {
                                this._closeForm();
                            } else {
                                return;
                            }
                        }
                    }
                });
        }
        else {
            (this._itemId ? this._assetTypeService.reactivateAssetType(obj) : this._assetTypeService.reactivateAssetTypeBatch(obj))

                .subscribe((response: any) => {
                    //this._closeForm(); //temp
                    if (response != null && response['message'] != null) {
                        this._layoutComponent.openPopup({
                            title: 'Alert',
                            message: response['message'],
                            withoutConfirm: true
                        });
                        if (response['close'] != null) {
                            if (response['close'] == true) {
                                this._closeForm();
                            } else {
                                return;
                            }
                        }
                    }
                });
        }
    }
    _ReactivateAssetModel(obj: any) {
        if (this._currentUser.isEnterprise) {
            (this._itemId ? this._assetModelService.reactivateModel(obj) : this._assetModelService.reactivateModelBatch(obj))

                .subscribe((response: any) => {
                    //this._closeForm(); //temp
                    if (response != null && response['message'] != null) {
                        this._layoutComponent.openPopup({
                            title: 'Alert',
                            message: response['message'],
                            withoutConfirm: true
                        });
                        if (response['close'] != null) {
                            if (response['close'] == true) {
                                this._closeForm();
                            } else {
                                return;
                            }
                        }
                    }
                });
        }
        else {
            (this._itemId ? this._assetModelService.reactivateModel(obj) : this._assetModelService.reactivateModelBatch(obj))

                .subscribe((response: any) => {
                    //this._closeForm(); //temp
                    if (response != null && response['message'] != null) {
                        this._layoutComponent.openPopup({
                            title: 'Alert',
                            message: response['message'],
                            withoutConfirm: true
                        });
                        if (response['close'] != null) {
                            if (response['close'] == true) {
                                this._closeForm();
                            } else {
                                return;
                            }
                        }
                    }
                });
        }
    }
    _ReactivateAsset(obj: any) {
        if (this._currentUser.isEnterprise) {
            (this._itemId ? this._assetService.reactivateAsset(obj) : this._assetService.reactivateAssetBatch(obj))

                .subscribe((response: any) => {
                    //this._closeForm(); //temp
                    if (response != null && response['message'] != null) {
                        this._layoutComponent.openPopup({
                            title: 'Alert',
                            message: response['message'],
                            withoutConfirm: true
                        });
                        if (response['close'] != null) {
                            if (response['close'] == true) {
                                this._closeForm();
                            } else {
                                return;
                            }
                        }
                    }
                });
        }
        else {
            (this._itemId ? this._assetService.reactivateAsset(obj) : this._assetService.reactivateAssetBatch(obj))

                .subscribe((response: any) => {
                    //this._closeForm(); //temp
                    if (response != null && response['message'] != null) {
                        this._layoutComponent.openPopup({
                            title: 'Alert',
                            message: response['message'],
                            withoutConfirm: true
                        });
                        if (response['close'] != null) {
                            if (response['close'] == true) {
                                this._closeForm();
                            } else {
                                return;
                            }
                        }
                    }
                });
        }
    }

    _ReactivateFundingSource(obj: any) {
        if (this._currentUser.isEnterprise) {
            (this._itemId ? this._fundingSourceService.reactivateFundingSource(obj) : this._fundingSourceService.reactivateFundingSourceBatch(obj))

                .subscribe((response: any) => {
                    //this._closeForm(); //temp
                    if (response != null && response['message'] != null) {
                        this._layoutComponent.openPopup({
                            title: 'Alert',
                            message: response['message'],
                            withoutConfirm: true
                        });
                        if (response['close'] != null) {
                            if (response['close'] == true) {
                                this._closeForm();
                            } else {
                                return;
                            }
                        }
                    }
                });
        }
        else {
            (this._itemId ? this._fundingSourceService.reactivateFundingSource(obj) : this._fundingSourceService.reactivateFundingSourceBatch(obj))

                .subscribe((response: any) => {
                    //this._closeForm(); //temp
                    if (response != null && response['message'] != null) {
                        this._layoutComponent.openPopup({
                            title: 'Alert',
                            message: response['message'],
                            withoutConfirm: true
                        });
                        if (response['close'] != null) {
                            if (response['close'] == true) {
                                this._closeForm();
                            } else {
                                return;
                            }
                        }
                    }
                });
        }
    }

    _ReactivateStatus(obj: any) {
        if (this._currentUser.isEnterprise) {
            (this._itemId ? this._statusesService.reactivateStatus(obj) : this._statusesService.reactivateStatusBatch(obj))

                .subscribe((response: any) => {
                    //this._closeForm(); //temp
                    if (response != null && response['message'] != null) {
                        this._layoutComponent.openPopup({
                            title: 'Alert',
                            message: response['message'],
                            withoutConfirm: true
                        });
                        if (response['close'] != null) {
                            if (response['close'] == true) {
                                this._closeForm();
                            } else {
                                return;
                            }
                        }
                    }
                });
        }
        else {
            (this._itemId ? this._statusesService.reactivateStatus(obj) : this._statusesService.reactivateStatusBatch(obj))

                .subscribe((response: any) => {
                    //this._closeForm(); //temp
                    if (response != null && response['message'] != null) {
                        this._layoutComponent.openPopup({
                            title: 'Alert',
                            message: response['message'],
                            withoutConfirm: true
                        });
                        if (response['close'] != null) {
                            if (response['close'] == true) {
                                this._closeForm();
                            } else {
                                return;
                            }
                        }
                    }
                });
        }
    }


    _ReactivateDepartment(obj: any) {
        if (this._currentUser.isEnterprise) {
            var accountsToSend: any[] = [];
            this._selectedAccounts.forEach((element: any) => {
                accountsToSend.push({ accountId: element });
            });
            obj.accountSites = accountsToSend;
            this._departmentsService.reactivateDepartment(obj)

                .subscribe((response: any) => {
                    //this._closeForm(); //temp
                    if (response != null && response['message'] != null) {
                        this._layoutComponent.openPopup({
                            title: 'Alert',
                            message: response['message'],
                            withoutConfirm: true
                        });
                        if (response['close'] != null) {
                            if (response['close'] == true) {
                                this._closeForm();
                            } else {
                                return;
                            }
                        }
                    }
                });
        }
        else {
            (this._itemId ? this._departmentsService.reactivateDepartment(obj) : this._departmentsService.reactivateBatchDepartment(obj))

                .subscribe((response: any) => {
                    //this._closeForm(); //temp
                    if (response != null && response['message'] != null) {
                        this._layoutComponent.openPopup({
                            title: 'Alert',
                            message: response['message'],
                            withoutConfirm: true
                        });
                        if (response['close'] != null) {
                            if (response['close'] == true) {
                                this._closeForm();
                            } else {
                                return;
                            }
                        }
                    }
                });
        }
    }

    _ReactivateStockItem(obj: any) {
        if (this._currentUser.isEnterprise) {
            this._stockItemsService.deactivateStockItem(obj)

                .subscribe((response: any) => {
                    //this._closeForm(); //temp
                    if (response != null && response['message'] != null) {
                        this._layoutComponent.openPopup({
                            title: 'Alert',
                            message: response['message'],
                            withoutConfirm: true
                        });
                        if (response['close'] != null) {
                            if (response['close'] == true) {
                                this._closeForm();
                            } else {
                                return;
                            }
                        }
                    }
                });
        }
        else {
            (this._itemId ? this._stockItemsService.reactivateStockItem(obj) : this._stockItemsService.reactivateStockItemBatch(obj))

                .subscribe((response: any) => {
                    //this._closeForm(); //temp
                    if (response != null && response['message'] != null) {
                        this._layoutComponent.openPopup({
                            title: 'Alert',
                            message: response['message'],
                            withoutConfirm: true
                        });
                        if (response['close'] != null) {
                            if (response['close'] == true) {
                                this._closeForm();
                            } else {
                                return;
                            }
                        }
                    }
                });
        }
    }

    _ReactivateUOMItem(obj: any) {
        if (this._currentUser.isEnterprise) {
            var accountsToSend: any[] = [];
            this._selectedAccounts.forEach((element: any) => {
                accountsToSend.push({ accountId: element });
            });
            obj.accountSites = accountsToSend;
            this._unitOfMeasuresService.reactivateUnitOfMeasure(obj)

                .subscribe((response: any) => {
                    //this._closeForm(); //temp
                    if (response != null && response['message'] != null) {
                        this._layoutComponent.openPopup({
                            title: 'Alert',
                            message: response['message'],
                            withoutConfirm: true
                        });
                        if (response['close'] != null) {
                            if (response['close'] == true) {
                                this._closeForm();
                            } else {
                                return;
                            }
                        }
                    }
                });
        }
        else {
            (this._itemId ? this._unitOfMeasuresService.reactivateUnitOfMeasure(obj) : this._unitOfMeasuresService.reactivateBatchUnitOfMeasure(obj))

                .subscribe((response: any) => {
                    //this._closeForm(); //temp
                    if (response != null && response['message'] != null) {
                        this._layoutComponent.openPopup({
                            title: 'Alert',
                            message: response['message'],
                            withoutConfirm: true
                        });
                        if (response['close'] != null) {
                            if (response['close'] == true) {
                                this._closeForm();
                            } else {
                                return;
                            }
                        }
                    }
                });
        }
    }
    _ReactivateCategory(obj: any) {
        if (this._currentUser.isEnterprise) {
            var accountsToSend: any[] = [];
            this._selectedAccounts.forEach((element: any) => {
                accountsToSend.push({ accountId: element });
            });
            obj.accountSites = accountsToSend;
            this._categoriesService.reactivateCategory(obj)

                .subscribe((response: any) => {
                    //this._closeForm(); //temp
                    if (response != null && response['message'] != null) {
                        this._layoutComponent.openPopup({
                            title: 'Alert',
                            message: response['message'],
                            withoutConfirm: true
                        });
                        if (response['close'] != null) {
                            if (response['close'] == true) {
                                this._closeForm();
                            } else {
                                return;
                            }
                        }
                    }
                });
        }
        else {
            (this._itemId ? this._categoriesService.reactivateCategory(obj) : this._categoriesService.reactivateBatchCategory(obj))

                .subscribe((response: any) => {
                    //this._closeForm(); //temp
                    if (response != null && response['message'] != null) {
                        this._layoutComponent.openPopup({
                            title: 'Alert',
                            message: response['message'],
                            withoutConfirm: true
                        });
                        if (response['close'] != null) {
                            if (response['close'] == true) {
                                this._closeForm();
                            } else {
                                return;
                            }
                        }
                    }
                });
        }
    }

    _ReactivateCustomers(obj: any) {
        if (this._currentUser.isEnterprise) {
            this._customersService.reactivateCustomer(obj)

                .subscribe((response: any) => {
                    //this._closeForm(); //temp
                    if (response != null && response['message'] != null) {
                        this._layoutComponent.openPopup({
                            title: 'Alert',
                            message: response['message'],
                            withoutConfirm: true
                        });
                        if (response['close'] != null) {
                            if (response['close'] == true) {
                                this._closeForm();
                            } else {
                                return;
                            }
                        }
                    }
                });
        }
        else {
            (this._itemId ? this._customersService.reactivateCustomer(obj) : this._customersService.reactivateCutemerBatch(obj))

                .subscribe((response: any) => {
                    //this._closeForm(); //temp
                    if (response != null && response['message'] != null) {
                        this._layoutComponent.openPopup({
                            title: 'Alert',
                            message: response['message'],
                            withoutConfirm: true
                        });
                        if (response['close'] != null) {
                            if (response['close'] == true) {
                                this._closeForm();
                            } else {
                                return;
                            }
                        }
                    }
                });
        }

    }
    _ReactivateVendor(obj: any) {
        if (this._currentUser.isEnterprise) {
            this._vendorsService.reactivateVendor(obj)

                .subscribe((response: any) => {
                    //this._closeForm(); //temp
                    if (response != null && response['message'] != null) {
                        this._layoutComponent.openPopup({
                            title: 'Alert',
                            message: response['message'],
                            withoutConfirm: true
                        });
                        if (response['close'] != null) {
                            if (response['close'] == true) {
                                this._closeForm();
                            } else {
                                return;
                            }
                        }
                    }
                });
        }
        else {
            (this._itemId ? this._vendorsService.reactivateVendor(obj) : this._vendorsService.reactivateVendorBatch(obj))

                .subscribe((response: any) => {
                    //this._closeForm(); //temp
                    if (response != null && response['message'] != null) {
                        this._layoutComponent.openPopup({
                            title: 'Alert',
                            message: response['message'],
                            withoutConfirm: true
                        });
                        if (response['close'] != null) {
                            if (response['close'] == true) {
                                this._closeForm();
                            } else {
                                return;
                            }
                        }
                    }
                });
        }
    }
    _ReactivateUser(obj: any) {
        (this._itemId ? this._usersService.reactivateUser(obj) : this._usersService.reactivateUserBatch(obj))

            .subscribe((response: any) => {
                //this._closeForm(); //temp
                if (response != null && response['message'] != null) {
                    this._layoutComponent.openPopup({
                        title: 'Alert',
                        message: response['message'],
                        withoutConfirm: true
                    });
                    if (response['close'] != null) {
                        if (response['close'] == true) {
                            this._closeForm();
                        } else {
                            return;
                        }
                    }
                }
            });
    }
    _ReactivatePerson(obj: any) {
        (this._itemId ? this._usersService.reactivatePerson(obj) : this._usersService.reactivatePersonBatch(obj))

            .subscribe((response: any) => {
                //this._closeForm(); //temp
                if (response != null && response['message'] != null) {
                    this._layoutComponent.openPopup({
                        title: 'Alert',
                        message: response['message'],
                        withoutConfirm: true
                    });
                    if (response['close'] != null) {
                        if (response['close'] == true) {
                            this._closeForm();
                        } else {
                            return;
                        }
                    }
                }
            });
    }

    _ReactivateAddress(obj: any) {
        if (this._currentUser.isEnterprise) {
            var accountsToSend: any[] = [];
            this._selectedAccounts.forEach((element: any) => {
                accountsToSend.push({ accountId: element });
            });
            obj.accountSites = accountsToSend;
            this._addressesService.reactivateAddress(obj)

                .subscribe((response: any) => {
                    //this._closeForm(); //temp
                    if (response != null && response['message'] != null) {
                        this._layoutComponent.openPopup({
                            title: 'Alert',
                            message: response['message'],
                            withoutConfirm: true
                        });
                        if (response['close'] != null) {
                            if (response['close'] == true) {
                                this._closeForm();
                            } else {
                                return;
                            }
                        }
                    }
                });
        }
        else {
            (this._itemId ? this._addressesService.reactivateAddress(obj) : this._addressesService.reactivateAddressBatch(obj))

                .subscribe((response: any) => {
                    //this._closeForm(); //temp
                    if (response != null && response['message'] != null) {
                        this._layoutComponent.openPopup({
                            title: 'Alert',
                            message: response['message'],
                            withoutConfirm: true
                        });
                        if (response['close'] != null) {
                            if (response['close'] == true) {
                                this._closeForm();
                            } else {
                                return;
                            }
                        }
                    }
                });
        }
    }
    _DeactivateFiles(obj: any) {
        if (this._currentUser.isEnterprise) {
            this._filesService.deactivateFiles(obj)

                .subscribe((response: any) => {
                    //this._closeForm(); //temp
                    if (response != null && response['message'] != null) {
                        this._layoutComponent.openPopup({
                            title: 'Alert',
                            message: response['message'],
                            withoutConfirm: true
                        });
                        if (response['close'] != null) {
                            if (response['close'] == true) {
                                this._closeForm();
                            } else {
                                return;
                            }
                        }
                    }
                });
        }
        else {
            (this._itemId ? this._filesService.deactivateFiles(obj) : this._filesService.deactivateFileBatch(obj))

                .subscribe((response: any) => {
                    //this._closeForm(); //temp
                    if (response != null && response['message'] != null) {
                        this._layoutComponent.openPopup({
                            title: 'Alert',
                            message: response['message'],
                            withoutConfirm: true
                        });
                        if (response['close'] != null) {
                            if (response['close'] == true) {
                                this._closeForm();
                            } else {
                                return;
                            }
                        }
                    }
                });
        }
    }
    _ReactivateLocation(obj: any) {
        (this._itemId ? this._locationsService.deactivateLocation(obj) : this._locationsService.reactivateBatchLocation(obj))

            .subscribe((response: any) => {
                //this._closeForm(); //temp
                if (response != null && response['message'] != null) {
                    this._layoutComponent.openPopup({
                        title: 'Alert',
                        message: response['message'],
                        withoutConfirm: true
                    });
                    if (response['close'] != null) {
                        if (response['close'] == true) {
                            this._closeForm();
                        } else {
                            return;
                        }
                    }
                }
            });
    }
    _ReactivateDisposeTo(obj: any) {
        (this._itemId ? this._disposeToService.reactivateDisposeTo(obj.id, obj) : this._disposeToService.reactivateBatchDisposeTo(obj))

            .subscribe((response: any) => {
                //this._closeForm();
                if (response != null && response['message'] != null) {
                    this._layoutComponent.openPopup({
                        title: 'Alert',
                        message: response['message'],
                        withoutConfirm: true
                    });
                    if (response['close'] != null) {
                        if (response['close'] == true) {
                            this._closeForm();
                        } else {
                            return;
                        }
                    }
                }
            });
    }
    _DeactivatePurchaseOrders(obj: any) {

        this._poService.reactivateDeactivateBatchPurchaseOrder(obj)

            .subscribe((response: any) => {
                //this._closeForm();
                if (response != null && response['message'] != null) {
                    this._layoutComponent.openPopup({
                        title: 'Alert',
                        message: response['message'],
                        withoutConfirm: true
                    });
                    if (response['close'] != null) {
                        if (response['close'] == true) {
                            this._closeForm();
                        } else {
                            return;
                        }
                    }
                }
            });
    }
    _DeactivateSalesOrders(obj: any) {
        this._soService.activedeactivateSaleOrderBatch(obj)

            .subscribe((response: any) => {
                //this._closeForm();
                if (response != null && response['message'] != null) {
                    this._layoutComponent.openPopup({
                        title: 'Alert',
                        message: response['message'],
                        withoutConfirm: true
                    });
                    if (response['close'] != null) {
                        if (response['close'] == true) {
                            this._closeForm();
                        } else {
                            return;
                        }
                    }
                }
            });
    }
    _DeactivateLocationType(obj: any) {
        if (this._securityService.currentUser.isEnterprise) {
            obj.accountSites = [];
        }
        (this._locationypesService.activatedeactivateLocationTypeBatch(obj))

            .subscribe((response: any) => {
                //this._closeForm(); //temp
                if (response.data['message'] != null) {
                    this._layoutComponent.openPopup({
                        title: 'Alert',
                        message: response.data['message'],
                        withoutConfirm: true
                    });
                    if (response.data['close'] != null) {
                        if (response.data['close'] == true) {
                            this._closeForm();
                        } else {
                            return;
                        }
                    }
                }
            });


    }
    _DeactivateSecurityLevel(obj: any) {

        if (this._currentUser.isEnterprise) {
            this._appRolesService.deactivateAppRole(obj)

                .subscribe((response: any) => {
                    //this._closeForm(); //temp
                    if (response != null && response['message'] != null) {
                        this._layoutComponent.openPopup({
                            title: 'Alert',
                            message: response['message'],
                            withoutConfirm: true
                        });
                        if (response['close'] != null) {
                            if (response['close'] == true) {
                                this._closeForm();
                            } else {
                                return;
                            }
                        }
                    }
                });
        }
        else {
            (this._itemId ? this._appRolesService.deactivateAppRole(obj) : null)

                .subscribe((response: any) => {
                    //this._closeForm(); //temp
                    if (response != null && response['message'] != null) {
                        this._layoutComponent.openPopup({
                            title: 'Alert',
                            message: response['message'],
                            withoutConfirm: true
                        });
                        if (response['close'] != null) {
                            if (response['close'] == true) {
                                this._closeForm();
                            } else {
                                return;
                            }
                        }
                    }
                });
        }
    }

    _ReactivateBuilding(obj: any) {
        this._BuildingService.activateAnddeactivateBuildingBatch(obj)

            .subscribe((response: any) => {
                //this._closeForm();
                if (response != null && response['message'] != null) {
                    this._layoutComponent.openPopup({
                        title: 'Alert',
                        message: response['message'],
                        withoutConfirm: true
                    });
                    if (response['close'] != null) {
                        if (response['close'] == true) {
                            this._closeForm();
                        } else {
                            return;
                        }
                    }
                }
            });
    }

    _ReactivateFacility(obj: any) {
        (this._itemId ? this._FacilityService.reactivateFacility(obj) :
            this._FacilityService.reactivateFacilityBatch(obj))

            .subscribe((response: any) => {
                //this._closeForm();
                if (response != null && response['message'] != null) {
                    this._layoutComponent.openPopup({
                        title: 'Alert',
                        message: response['message'],
                        withoutConfirm: true
                    });
                    if (response['close'] != null) {
                        if (response['close'] == true) {
                            this._closeForm();
                        } else {
                            return;
                        }
                    }
                }
            });


    }
    _ReactivateAssetPurchaseOrders(obj: any) {

        this._assetPurchaseOrdersService.reactivateDeactivateBatchPurchaseOrder(obj)

            .subscribe((response: any) => {
                //this._closeForm();
                if (response != null && response['message'] != null) {
                    this._layoutComponent.openPopup({
                        title: 'Alert',
                        message: response['message'],
                        withoutConfirm: true
                    });
                    if (response['close'] != null) {
                        if (response['close'] == true) {
                            this._closeForm();
                        } else {
                            return;
                        }
                    }
                }
            });
    }
    _ReactivateAssetReservation(obj: any) {

        this._assetReservationService.reactivateDeactivateBatchAssetReservation(obj)

            .subscribe((response: any) => {
                //this._closeForm();
                if (response != null && response['message'] != null) {
                    this._layoutComponent.openPopup({
                        title: 'Alert',
                        message: response['message'],
                        withoutConfirm: true
                    });
                    if (response['close'] != null) {
                        if (response['close'] == true) {
                            this._closeForm();
                        } else {
                            return;
                        }
                    }
                }
            });
    }


    _ReactivateFloor(obj: any) {
        this._FloorService.reactivateAnddeactivateFloorBatch(obj)

            .subscribe((response: any) => {
                if (response != null && response['message'] != null) {
                    this._layoutComponent.openPopup({
                        title: 'Alert',
                        message: response['message'],
                        withoutConfirm: true
                    });
                    if (response['close'] != null) {
                        if (response['close'] == true) {
                            this._closeForm();
                        } else {
                            return;
                        }
                    }
                }
            });
    }

    _ReactivateScheduleMaintenance(obj: any) {
        this._scheduleMaintenanceService.batchActivateDeactivate(obj)
            .subscribe((response: any) => {
                if (response != null && response['message'] != null) {
                    this._layoutComponent.openPopup({
                        title: 'Alert',
                        message: response['message'],
                        withoutConfirm: true
                    });
                    if (response['close'] != null) {
                        if (response['close'] == true) {
                            this._closeForm();
                        } else {
                            return;
                        }
                    }
                }
            });
    }

    private _initForm() {
        this._form = this._fb.group({
            note: ['', [Validators.required]],
        });
    }


}
